// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3NRCl";
var _3 = "header-1hSq6";
var _4 = "header__icon-TqAdl";
var _5 = "header__badge-1fSga";
export { _1 as "__esModule", _2 as "root", _3 as "header", _4 as "header__icon", _5 as "header__badge" }
export default { "__esModule": _1, "root": _2, "header": _3, "header__icon": _4, "header__badge": _5 }
